import React from 'react';

import PanduLogoWhite from '../assets/pandu-logo-white';
import { ROUTES } from '../helpers/constants';

const LINKS = [
  { href: ROUTES.trans_schedule, label: 'Informasi Angkutan' },
  { href: ROUTES.traffic, label: 'Informasi Lalu Lintas' },
  { href: ROUTES.tour, label: 'Informasi Wisata' },
  { href: ROUTES.licensing, label: 'Informasi Perizinan' }
];

const PRESENTED = [
  { sourceImage: '/pemprov-jabar-logo.png', alt: 'pemprov-jawa-barat' },
  { sourceImage: '/dishub-logo.png', alt: 'dinas-perhubungan' },
  { sourceImage: '/dishub-jabar-logo.png', alt: 'pemprov-jawa-barat' },
  { sourceImage: '/great-dishub-jabar-logo.png', alt: 'dinas-perhubungan-jawa-barat' }
];

const Footer = () => {
  return (
    <footer className="bg-primary-800">
      <div className="mx-auto w-full max-w-screen-xl lg:p-4 p-10 lg:py-8">
        <div className="md:flex md:justify-between gap-16">
          <div className="mb-6 md:mb-0 md:w-5/12">
            <a href="#" className="flex items-center mb-5">
              <PanduLogoWhite />
            </a>
            <p className="text-left text-white text-base opacity-60">
              Pandu Jalan adalah Sistem Informasi Perjalanan yang dibuat dan dikelola oleh Dinas
              Perhubungan Provinsi Jawa Barat untuk membantu masyarakat bepergian di wilayah Jawa
              Barat.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 sm:gap-6 md:w-6/12">
            <div>
              <h2 className="mb-6 text-xl font-bold text-white text-left">Tautan</h2>
              <ul className="text-white opacity-60 font-medium text-left">
                {LINKS.map((link) => (
                  <li className="mb-5" key={link.href}>
                    <a href={link.href} className="hover:underline">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="mb-6 text-xl font-bold text-white text-left">Dipersembahkan Oleh</h2>
              <ul className="font-medium bg-white flex gap-4 p-3 rounded">
                {PRESENTED.map((item) => (
                  <li className="inline-flex" key={item.alt}>
                    <img alt={item.alt} src={item.sourceImage} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <hr className="my-6 border-gray-600 sm:mx-auto lg:my-8" />
        <div className="text-left text-sm text-white">
          SIPANDU JALAN © {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
